var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOrigin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 24,
    viewBox: "0 0 66 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_3947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8757 0H15.0771V13.9448L19.8757 12.9915V0Z",
    fill: "#1770B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83353 7.81245L9.36812 15.0799L13.8212 14.1949L4.95194 0H0V16.9416L4.83353 15.9805V7.81245Z",
    fill: "#1770B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9335 24H19.8758V12.9915L15.0772 13.9448V16.2032L13.8212 14.1949L9.36816 15.0799L14.9335 24Z",
    fill: "#2F3140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83353 23.998V15.9805L0 16.9416V24L4.83353 23.998Z",
    fill: "#2F3140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7034 0H46.1514L48.5041 7.30256L52.7785 6.45275L50.7034 0Z",
    fill: "#1770B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0001 0H61.4519L59.8311 5.05201L64.6879 4.08694L66.0001 0Z",
    fill: "#1770B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2952 24L64.6875 4.08691L59.8307 5.05199L56.0823 16.7209L52.7784 6.45273L48.5039 7.30254L53.881 24H58.2952Z",
    fill: "#2F3140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9369 0H37.9674L33.0058 8.00391L28.0539 0C28.0539 0 23.0126 0 23.0728 0C23.0709 0 28.116 8.12503 29.9019 10.9988L36.9833 9.59219L42.9369 0Z",
    fill: "#1770B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0688 24.0001H28.0091L33.0077 16.0118L37.9926 24.0001H42.9465L35.4691 12.0343L36.9851 9.59424L29.9037 11.0008C30.2881 11.6182 30.523 11.9991 30.523 11.9991L23.0708 24.0021L23.0688 24.0001Z",
    fill: "#2F3140"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_3947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrigin);
export default __webpack_public_path__ + "static/media/Logo_Origin.529bba80.svg";
export { ForwardRef as ReactComponent };